<template>
    <div class="loader-wrapper">
        <div>
            <div class="loader">
                <svg class="circular" viewBox="25 25 50 50">
                    <circle
                    class="path"
                    cx="50"
                    cy="50"
                    r="20"
                    fill="none"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    ></circle>
                </svg>
            </div>
            <div class="loader__label" v-if="loaderText">{{loaderText}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Loader',
        props: {
            loaderText: {
                type: String,
                required: false,
                default: ""
            }
        }
    }
</script>

<style lang="scss" scoped>
@import '@/assets/scss/__variables.scss';
.loader-wrapper {
    position: fixed;
    left:0;
    right:0;
    top:0;
    bottom:0;
    z-index:999999;
    display:flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255,255,255,.7);
}
.loader {
  width: 100px;
  position: relative;
  margin: 0 auto;

  &::before {
    content: '';
    display: block;
    padding-top: 100%;
  }
}

.circular {
  animation: rotate 2s linear infinite;
  height: 100%;
  transform-origin: center center;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.path {
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  animation: dash 1.5s ease-in-out infinite;
  stroke-linecap: round;
  stroke:$blue;
}

.loader__label {
    font-size: 16px;
    font-weight: 700;
    color:$blue;

    @media (min-width: $lg) {
        font-size: 18px;
    }
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}
</style>